import type { MoneyV2 } from 'services/shopify';
import type { Money } from 'types/product/Money';

export function formatShopifyPrice(price: MoneyV2): Money {
  return { amount: Number(price.amount), currencyCode: price.currencyCode };
}
